import isEmpty from './isEmpty'
import createTempId from './createTempId'
//----------------------------------------------
// convert starter counts (to character counts)
//----------------------------------------------
export default function convertStarterCounts(starter_counts) {
  console.log('-----------------------')
  console.log('IN convertStarterCounts')

  if (isEmpty(starter_counts)) {
    return null
  }

  let counts = starter_counts.map((s) => {
    
    const name = s.name ?? ''
    const value = s.value ?? ''
    const temp_id = createTempId()

    return {
      character: 0,
      id: temp_id,
      name: name,
      value: value,
      starter: true,
    }
  })

  console.log('converted counts = ', counts)
  return counts
}
